"use strict";

var moment = require('moment');

var ShineProducts = require('../../products');

var Order = require('../classes/Order');

function parseCustomerName(name) {
  var customer_name = name.replace('&#39;', '\'').split(' ');
  var firstname;
  var lastname;

  if (customer_name.length === 2) {
    firstname = customer_name[0];
    lastname = customer_name[1];
  } else if (customer_name.length > 2) {
    firstname = customer_name[0];
    lastname = customer_name[customer_name.length - 1];
  } else {
    firstname = name;
    lastname = '';
  }

  return {
    lastname: lastname,
    firstname: firstname
  };
}

function parseShippingType(receipt) {
  var shipping_type;
  var shipping_options = this.shipping_options.map(function (opt) {
    return opt.title;
  });

  if (receipt && receipt.shipping_details && receipt.shipping_details.shipping_method) {
    var shipping_method = receipt.shipping_details.shipping_method;

    if (shipping_method.match(/priority/i)) {
      shipping_type = shipping_options.filter(function (title) {
        return title.match(/priority/i);
      });
    } else if (shipping_method.match(/standard/i)) {
      shipping_type = shipping_options.filter(function (title) {
        return title.match(/priority|standard|first/i);
      });
    } else if (shipping_method.match(/express/i)) {
      shipping_type = shipping_options.filter(function (title) {
        return title.match(/express/i);
      });
    } else if (shipping_method.match(/1 day/i)) {
      shipping_type = shipping_options.filter(function (title) {
        return title.match(/next/i) || title.match(/one/i);
      });
    } else if (shipping_method.match(/worldwide/i)) {
      shipping_type = shipping_options.filter(function (title) {
        return title.match(/worldwide/i);
      });
    } else {
      console.log("Etsy shipping method \"".concat(shipping_method, "\" did not match a choice"));
      shipping_type = [];
    }
  }

  if (shipping_type.length > 1) {
    console.warn("Shipping type \"".concat(receipt.shipping_details.shipping_method, "\" matched multiple methods:"), shipping_type);
  }

  this.shipping_type = shipping_type[0];
}
/**
 * @function fromEtsyOrder
 * @param {Array} transactions
 * @param {Object} receipt
 * @param {Object} options
 */


function fromEtsyOrder(receipt, transactions, options) {
  if (!receipt) {
    throw new Error('receipt is required');
  }

  if (!transactions) {
    throw new Error('transactions is required');
  }

  if (!Array.isArray(transactions)) {
    throw new Error('transactions must be an array');
  }

  var countryCodes = options.etsy.countryCodes;

  var _parseCustomerName = parseCustomerName(receipt.name),
      lastname = _parseCustomerName.lastname,
      firstname = _parseCustomerName.firstname;

  var products = transactions.map(function (transaction) {
    return ShineProducts.instance().fromEtsyTransaction(transaction, receipt);
  });
  var order = new Order({
    oid: receipt.receipt_id || '',
    order_date: moment(receipt.creation_tsz * 1000) || '',
    email: receipt.buyer_email || '',
    lastname: lastname || '',
    firstname: firstname || '',
    address1: receipt.first_line || '',
    address2: receipt.second_line || '',
    city: receipt.city || '',
    state: receipt.state || '',
    zip: receipt.zip || '',
    country: countryCodes[receipt.country_id],
    sales_channel: 'etsy',
    printing_type: 'STD',
    shipping_amount: receipt && receipt.total_shipping_cost || 0,
    client_payment: receipt.was_paid ? parseFloat(receipt.grandtotal, 10) : 0,
    products: products
  });
  parseShippingType.call(order, receipt);
  return order;
}

module.exports = fromEtsyOrder;